import {createAction, props} from '@ngrx/store';
import {PlanSubscription} from '@automata/services/plan.service';

export const LoadSubscriptions = createAction('[Subscriptions] Load');
export const LoadSubscriptionsComplete = createAction('[Subscriptions] Load Complete', props<{subscriptions: PlanSubscription[]}>());
